import styled, { css } from "styled-components";

export const StyledButton = styled.button`
  padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.borderRadius};
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSizes.md};
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;


  ${({ $variant, theme }) => {
    switch ($variant) {
      case "secondary":
        return css`
          background-color: ${theme.colors.lightGray};
          color: ${theme.colors.text};
        `;
      case "save":
        return css`
          background-color: ${theme.colors.accent};
          color: ${theme.colors.background};
        `;
      case "cancel":
        return css`
          background-color: #ccc;
          color: #333;
        `;
      case "login":
        return css`
          background-color: ${theme.colors.loginButton};
          color: #fff;
          width: 100%;
        `;
      case "ghost":
        return css`
          background: transparent;
          color: ${theme.colors.text};
          padding: 0.4rem;
          border-radius: 50%;
          &:hover {
            background: ${theme.colors.lightGray};
          }
        `;
        case "create":
          return css`
          background-color: ${theme.colors.loginButton};
          color: #fff;
          width: 100%;
          margin: 1rem 0 2rem 0;
          max-width: 600px;
        `;
        case "portfolio":
          return css`
            min-width: 150px;
            position: absolute;
            bottom: 25%;
            right: 15%;
            padding: 8px 16px;
            background-color: ${({ theme }) => theme.primary};
            color: #ffffff;
            text-decoration: none;
            text-transform: uppercase;
            border: 2px solid;
            border-radius: 0; /* bordes redondeados */
            z-index: 10; /* siempre encima del overlay */
            transition: inherit;
            letter-spacing: 0.05em;
            font-size: 24px;
            font-weight: 700;
          `;
        case "send":
        return css`
          background-color: ${theme.colors.sendButton};
          color: #fff;
          transition: transform 0.3s ease;

          &:hover {
          transform: scale(1.05);
          }
        `;

        case"more":
        return css`
        background-color: ${theme.colors.border};
        color: ${theme.colors.background};
        transition: transform 0.3s ease;

        &:hover {
        transform: scale(1.05);
        }
      `;

      case "request":
        return css`
        background-color: #2c2c2c;
        color: #fff;
        `;

        default:
          return css`
            background-color: ${theme.colors.primary};
            color: ${theme.colors.background};
          `;
    }
  }}

  &:hover {
    opacity: 0.9;
    transform: scale(1.03);

  }
`;
